module.exports = __webpack_public_path__ + "img/refresh.1ef2c0ec.svg";